import { createFileRoute } from '@tanstack/react-router'
import { CacheType } from 'siteline-common-all/enums'
import { z } from 'zod'
import { looseString } from '../common/util/SearchParams'
import Caching from '../components/caching/Caching'

export const Route = createFileRoute('/_a/caching')({
  component: Caching,
  validateSearch: z.object({
    pattern: looseString.optional(),
    cacheType: z.enum(CacheType).optional(),
  }),
})
